import apiFetch from '../apiFetch'

export default function (token, roleId) {
  return apiFetch({ endPoint: `role/${roleId}`, method: 'GET', body: null, token: token })
}
